import React, { useMemo, useState } from 'react'

import {
  GuidelineDrawerContext,
  GuidelineDrawerState,
  guidelineDrawerContext,
} from '@/pages/funds/ic-guidelines-v2/components/GuidelineDrawerContext'

export const GuidelineDrawerProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [drawer, setDrawer] = useState<GuidelineDrawerState>({
    open: false,
    mode: 'create',
  })

  const value = useMemo<GuidelineDrawerContext>(() => {
    const openCreate = () => {
      setDrawer({
        open: true,
        mode: 'create',
      })
    }

    const openEdit = (guidelineId: number) => {
      setDrawer({
        open: true,
        mode: 'edit',
        guidelineId,
      })
    }

    const close = () => {
      setDrawer({
        open: false,
        mode: 'create',
      })
    }

    return {
      drawer,
      setDrawer,
      openCreate,
      openEdit,
      close,
    }
  }, [drawer])

  return <guidelineDrawerContext.Provider value={value}>{children}</guidelineDrawerContext.Provider>
}
